import { atom } from "recoil";

type User = {
  mailAddress: string;
};

export const authAtom = atom({
  key: "authAtom",
  default: (() => {
    const user = localStorage.getItem("user");
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
    return {
      isAuthenticated,
      user: user ? JSON.parse(user) : null,
    };
  })(),
});
